import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraControl } from '../../models/doraControl.ts';

interface DoraControlState {
  doraControls: DoraControl[];
  selectedDoraControl: DoraControl | null;
}

const initialState: DoraControlState = {
  doraControls: [],
  selectedDoraControl: null,
};

const doraControlSlice = createSlice({
  name: 'doraControl',
  initialState,
  reducers: {
    setDoraControls(state, action: PayloadAction<DoraControl[]>) {
      state.doraControls = action.payload;
    },
    addDoraControl(state, action: PayloadAction<DoraControl>) {
      state.doraControls.push(action.payload);
    },
    updateDoraControl(state, action: PayloadAction<DoraControl>) {
      const index = state.doraControls.findIndex(control => control.id === action.payload.id);
      if (index !== -1) state.doraControls[index] = action.payload;
    },
    removeDoraControl(state, action: PayloadAction<number>) {
      state.doraControls = state.doraControls.filter(control => control.id !== action.payload);
    },
    setSelectedDoraControl(state, action: PayloadAction<DoraControl | null>) {
      state.selectedDoraControl = action.payload;
    },
  },
});

export const {
  setDoraControls,
  addDoraControl,
  updateDoraControl,
  removeDoraControl,
  setSelectedDoraControl,
} = doraControlSlice.actions;

export const selectDoraControls = (state: RootState) => state.doraControl.doraControls;
export const selectSelectedDoraControl = (state: RootState) => state.doraControl.selectedDoraControl;

export default doraControlSlice.reducer;
